import { filterPage } from "components/common/Filters/FiltersHelper";
import { isEmpty } from "lodash";
import { useAppSelector } from "redux/hooks";
import { corpViewTypes } from "utils/CommonConstants";
import { formFilterRequestPayload } from "utils/CommonFunctions";

export const tabs = {
  properties: "Properties",
  template_plans: "Template Plans",
  library_plans: "Library Plans"
};

export const getFilterRequestPayload = (view: string, globalFiltersforPage: any) =>
  view === corpViewTypes.dashboard
    ? globalFiltersforPage?.isFilterApplied
      ? globalFiltersforPage?.modifiedFilter
      : globalFiltersforPage?.defaultFilter
    : (isEmpty(globalFiltersforPage?.modifiedFilter)
        ? globalFiltersforPage?.defaultFilter
        : globalFiltersforPage?.modifiedFilter) || [];

export const useFilterRequestPayload = (view: string, selectedListType: string) => {
  const globalFiltersforPage = useAppSelector(
    (state) =>
      state.globalFilters[
        selectedListType === "default"
          ? filterPage.dashboardDisplay
          : selectedListType === "consultant"
          ? filterPage.consultantListDisplay
          : filterPage.listDisplay
      ]
  );
  const dynamicSelectFlag = globalFiltersforPage?.dynamicSelectAll;
  const filterRequestPayload = getFilterRequestPayload(view, globalFiltersforPage);
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);

  return { globalFiltersforPage, dynamicSelectFlag, filterRequestPayload, formattedFilterRequestPayload };
};
